
{
  "fr": {
    "checkout": {
      "cgv": "Vous devez accepter nos CGVs pour accéder au paiement"
    }
  }
}
